import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Card, Grid, Form, Button} from 'semantic-ui-react';
import {hasAccessPermission} from '../../../common/permissions/validations';
import {paths} from '../../../common/dictionaries/urls';
import {resources, scopes} from '../../../common/permissions/dictionary';
import {parsePartsForOrders} from '../../utils';
import {Actions} from '../../../common/actions';
import FilterForm from './FilterForm';
import PartsOrdersTable from './PartsOrdersTable';
import GenerateButton from '../../../providerOrders/components/manual/generator';
import './styles.scss';

const initialParameters = {'provider': '31', 'transport': 'M', 'orderType': '00'};

class CampaignPartsOrders extends Component {
  componentDidMount() {
    const {campaingNo, partNo, permissions} = this.props;

    if (!hasAccessPermission(permissions, resources.MaintainCampaign, scopes.Create)) {
      this.props.navigateTo(paths.AccessDenied);
    }
    this.props.clearCampaign();
    this.props.loadProviders({'withOrigin': true});
    this.handleAllParametersChange(initialParameters);

    if (partNo) {
      this.props.fetchPartsByCampaignNo({campaingNo, partNo});
    } else {
      this.props.fetchPartsByCampaignNo({campaingNo});
    }
  }

  componentDidUpdate(prevProps) {
    const {partsArray, detail} = this.props;

    if (!prevProps.partsArray.length && partsArray.length !== detail.length) {
      const partsOrders = parsePartsForOrders(partsArray);
      this.props.changeProviderManualOrderParameter('detail', partsOrders);
    }
  }

  componentWillUnmount() {
    this.props.clearCampaign();
  }

  handleSingleParameterChange = (e, {name, value}) => {
    this.props.changeProviderManualOrderParameter(name, value);
  };

  handleAllParametersChange = (parameters) => {
    this.props.changeProviderManualOrderAllParameter(parameters);
  };

  handleClearClick = () => {
    const parameters = {'provider': '', 'transport': '', 'orderType': ''};
    this.handleAllParametersChange(parameters);
  }

  render() {
    const {
      detail,
      providers,
      provider,
      transport,
      orderType,
      loadingOrder,
      loadingPartsArray,
      editProviderManualOrderElementQuantity,
    } = this.props;

    return (
      <div className='campaign-parts-manual-orders'>
        <Card raised fluid>
          <Grid padded>
            <Grid.Row>
              <Grid.Column textAlign='left'>
                <h2>Pedidos de Partes</h2>
              </Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width='10' textAlign='left'>
                <Form>
                  <Form.Group widths='equal'>
                    <FilterForm
                      provider={provider}
                      transport={transport}
                      orderType={orderType}
                      providers={providers}
                      disabled={loadingOrder}
                      handleChange={this.handleSingleParameterChange}
                    />
                  </Form.Group>
                </Form>
              </Grid.Column>
              <Grid.Column width='6' textAlign='right' verticalAlign='middle'>
                <Button
                  secondary
                  disabled={loadingPartsArray || loadingOrder}
                  content='LIMPIAR'
                  onClick={this.handleClearClick}
                />
                <GenerateButton />
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Card>
        <Card raised fluid>
          <PartsOrdersTable
            partsOrders={detail}
            loadingOrder={loadingOrder}
            loadingPartsArray={loadingPartsArray}
            editProviderManualOrderElementQuantity={editProviderManualOrderElementQuantity}
          />
        </Card>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    'campaingNo': ownProps.params && ownProps.params.id,
    'partNo': ownProps.params && ownProps.params.partno,
    'permissions': state.session.permissions,
    'providers': state.provider.list,
    'loadingPartsArray': state.campaignParts.loading,
    'partsArray': state.campaignParts.partsArray,
    'loadingOrder': state.providerManualOrder.loading,
    'detail': state.providerManualOrder.detail,
    'provider': state.providerManualOrder.provider,
    'transport': state.providerManualOrder.transport,
    'orderType': state.providerManualOrder.orderType,
  };
};

const {
  withRouter,
  navigateTo,
  loadProviders,
  clearCampaign,
  fetchPartsByCampaignNo,
  changeProviderManualOrderParameter,
  changeProviderManualOrderAllParameter,
  editProviderManualOrderElementQuantity,
} = Actions;

export default withRouter(
  connect(mapStateToProps, {
    navigateTo,
    loadProviders,
    clearCampaign,
    fetchPartsByCampaignNo,
    changeProviderManualOrderParameter,
    changeProviderManualOrderAllParameter,
    editProviderManualOrderElementQuantity,
  })(CampaignPartsOrders)
);
